// src/services/pedidos/PedidoService.js
import { deleteData, fetchBlobData, fetchData, postData, putData } from '../Api';

const pad2 = (value) => value.toString().padStart(2, '0');

const formatDateTimeLocal = (value) => {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
    return value;
  }

  return [
    value.getFullYear(),
    pad2(value.getMonth() + 1),
    pad2(value.getDate()),
  ].join('-') + `T${[
    pad2(value.getHours()),
    pad2(value.getMinutes()),
    pad2(value.getSeconds()),
  ].join(':')}`;
};

export const getDashPedido = async ({ dataHoraI, dataHoraF }) => {
  return fetchData('/Pedido/GetDashPedido', {
    dataHoraI: formatDateTimeLocal(dataHoraI),
    dataHoraF: formatDateTimeLocal(dataHoraF),
  });
};

export const getRelatorioVendasGarcom = async ({ dataHoraIni, dataHoraFim, usuarioId = 0 }) => {
  return fetchData('/Pedido/GetRelatorioVendasGarcom', {
    dataHoraIni,
    dataHoraFim,
    usuarioId,
  });
};

export const getPedidoByIdService = async (pedidoId) => {
  return fetchData('/Pedido/GetPedidoById', { pedidoId });
};

export const getPedidoPDFByIdService = async ({ pedidoId, paperWidthMm = 55 }) => {
  return fetchBlobData('/Relatorio/PedidoPDFById', { pedidoId, paperWidthMm });
};

export const getResumoPedidosPDFService = async ({
  dataIni,
  dataFim,
  statusPedido,
  formaPagId,
  paperWidthMm = 76,
}) => fetchBlobData('/Relatorio/ResumoPedidosPDF', {
  dataIni,
  dataFim,
  statusPedido,
  formaPagId,
  paperWidthMm,
});

export const getResumoItensPedidosPDFService = async ({
  dataIni,
  dataFim,
  statusPedido,
  descricaoProduto,
  paperWidthMm = 76,
}) => fetchBlobData('/Relatorio/ResumoItensPedidosPDF', {
  dataIni,
  dataFim,
  statusPedido,
  descricaoProduto,
  paperWidthMm,
});

export const getComandasPDFByIdsService = async ({ comandaIds, paperWidthMm = 75 }) => {
  const params = new URLSearchParams();
  (comandaIds || []).forEach((comandaId) => params.append('comandaIds', comandaId));
  params.append('paperWidthMm', paperWidthMm);

  return fetchBlobData(`/Relatorio/ComandasPDFByIds?${params.toString()}`);
};

export const getComandaPDFByPedidoIdService = async ({ pedidoId, paperWidthMm = 75 }) => {
  return fetchBlobData('/Relatorio/ComandaPDFByPedidoId', { pedidoId, paperWidthMm });
};

export const createPedido = async (pedido) => {
  return postData('/Pedido', pedido);
};

export const salvarPedidoGarcom = async ({ pedido, comandaId }) => {
  return postData('/Pedido/SalvarPedidoGarcom', {
    pedido,
    comandaId,
  });
};

export const salvarPedidoAvulsoGarcom = async ({ pedido, pedidoItem, comandaId }) => {
  return postData('/Pedido/SalvarPedidoGarcom', {
    pedido,
    comandaId,
    pedidoItemAvulso: {
      ...pedidoItem,
      id: 0,
    },
  });
};

export const updatePedidoService = async (pedido) => {
  return putData('/Pedido', pedido);
};

export const enviarAlteracaoPedidoWhats = async (pedidoId) => {
  return postData(`/Pedido/EnviarAlteracaoPedido?pedidoId=${pedidoId}`, {});
};

export const deletePedidoService = async (pedidoId) => {
  return deleteData('/Pedido', { pedidoId });
};

export const alterarStatusPedido = async ({ pedidoId, statusPedido, tempoPreparoMinutos = null }) => {
  return putData('/Pedido/AlteraStatusPedido', {
    pedidoId,
    statusPedido,
    tempoPreparoMinutos,
  });
};

export const atualizarPixPago = async ({ pedidoId, pixPago }) => {
  return putData('/Pedido/AtualizarPixPago', {
    pedidoId,
    pixPago,
  });
};

export const existeNotaPorPedidoService = async (pedidoId) => {
  return fetchData('/Nota/ExistePorPedido', { pedidoId });
};
